
export const swaapURI = "https://swaap.finance"

export const IMAGES_FOLDER = "assets/images/"

export const weiFormat = "ether";
export const weiPrecision = 18;

export const secondToAnnualFactor = 60 * 60 * 24 * 365

export const floatPlaceholder = "0.0";
export const integerPlaceholder = "0";

export const chainMapping = {
	42: {
		contract: "0xa2749f89B68f88521abAcd0c01c508cD4B67Cc08",
		whitelist: {
			"0xd0a1e359811322d97991e03f863a0c30c2cf029c": {
				symbol: "ETH",
				name: "Ether",
				address: "0xd0a1e359811322d97991e03f863a0c30c2cf029c",
				oracle: "0x9326BFA02ADD2366b30bacB125260Af641031331"
			},
			"0xa0a5ad2296b38bd3e3eb59aaeaf1589e8d9a29a9": {
				symbol: "BTC",
				name: "Bitcoin",
				address: "0xa0a5ad2296b38bd3e3eb59aaeaf1589e8d9a29a9",
				oracle: "0x6135b13325bfC4B00278B4abC5e20bbce2D6580e"
			},
			"0x9b6ff80ff8348852d5281de45e66b7ed36e7b8a9": {
				symbol: "UNI",
				name: "Uniswap",
				address: "0x9b6ff80ff8348852d5281de45e66b7ed36e7b8a9",
				oracle: "0xDA5904BdBfB4EF12a3955aEcA103F51dc87c7C39",
			},
			"0xa36085f69e2889c224210f603d836748e7dc0088": {
				symbol: "LINK",
				name: "Chainlink",
				address: "0xa36085f69e2889c224210f603d836748e7dc0088",
				oracle: "0x396c5E36DD0a0F5a5D33dae44368D4193f69a1F0",
			},
			"0x9e9137f8ba2ca0fded90d959a4bb3ba6a3fb184f": {
				symbol: "BNB",
				name: "BNB",
				address: "0x9e9137f8ba2ca0fded90d959a4bb3ba6a3fb184f",
				oracle: "0x8993ED705cdf5e84D0a3B754b5Ee0e1783fcdF16",
			},
		},
		defaultToken: "0xd0a1e359811322d97991e03f863a0c30c2cf029c",
		chain: "Kovan",
		network: "Ethereum"
	},
	97: {
		contract: "0x1c94a095eab02BE16eae7a67ABc0d083BAbf738B",
		whitelist: {
			"0xd66c6b4f0be8ce5b39d52e0fd1344c389929b378": {
				symbol: "ETH",
				name: "Ether",
				address: "0xd66c6b4f0be8ce5b39d52e0fd1344c389929b378",
				oracle: "0x143db3CEEfbdfe5631aDD3E50f7614B6ba708BA7"
			},
			"0x6ce8da28e2f864420840cf74474eff5fd80e65b8": {
				symbol: "BTC",
				name: "Bitcoin",
				address: "0x6ce8da28e2f864420840cf74474eff5fd80e65b8",
				oracle: "0x5741306c21795FdCBb9b265Ea0255F499DFe515C"
			},
			"0x84b9b910527ad5c03a9ca831909e21e236ea7b06": {
				symbol: "LINK",
				name: "Chainlink",
				address: "0x84b9b910527ad5c03a9ca831909e21e236ea7b06",
				oracle: "0x1B329402Cb1825C6F30A0d92aB9E2862BE47333f",
			},
			"0xae13d989daC2f0dEbFf460aC112a837C89BAa7cd": {
				symbol: "BNB",
				name: "BNB",
				address: "0xae13d989daC2f0dEbFf460aC112a837C89BAa7cd",
				oracle: "0x2514895c72f50D8bd4B4F9b1110F0D6bD2c97526",
			},
		},
		defaultToken: "0xd66c6b4f0be8ce5b39d52e0fd1344c389929b378",
		chain: "Testnet",
		network: "Binance Smart Chain"
	},
	80001: {
		contract: "0xaF7D943eb4DB971ceEE8b9083127ea7140ad1e7B",
		whitelist: {
			"0x062f24cb618e6ba873ec1c85fd08b8d2ee9bf23e": {
				symbol: "ETH",
				name: "Ether",
				address: "0x062f24cb618e6ba873ec1c85fd08b8d2ee9bf23e",
				oracle: "0x0715A7794a1dc8e42615F059dD6e406A6594651A"
			},
			"0x8728543e9239c16b7b4dcab09127f3e128682843": {
				symbol: "BTC",
				name: "Bitcoin",
				address: "0x8728543e9239c16b7b4dcab09127f3e128682843",
				oracle: "0x007A22900a3B98143368Bd5906f8E17e9867581b"
			},
			"0x9c3c9283d3e44854697cd22d3faa240cfb032889": {
				symbol: "MATIC",
				name: "Matic",
				address: "0x9c3c9283d3e44854697cd22d3faa240cfb032889",
				oracle: "0xd0D5e3DB44DE05E9F294BB0a3bEEaF030DE24Ada",
			},
		},
		defaultToken: "0x062f24cb618e6ba873ec1c85fd08b8d2ee9bf23e",
		chain: "Mumbai",
		network: "Matic"
	},
	43113: {
		contract: "0xa57d368f64d842f4a3c068b80799c401642a79b9",
		whitelist: {
			"0x969771454b8a9b40e5578d38f16c91313fa67baf": {
				symbol: "ETH",
				name: "Ether",
				address: "0x969771454b8a9b40e5578d38f16c91313fa67baf",
				oracle: "0x86d67c3D38D2bCeE722E601025C25a575021c6EA"
			},
			"0x29d861c32f28112547cf5e2d7487b33506570981": {
				symbol: "BTC",
				name: "Bitcoin",
				address: "0x29d861c32f28112547cf5e2d7487b33506570981",
				oracle: "0x31CF013A08c6Ac228C94551d535d5BAfE19c602a"
			},
			"0xd00ae08403b9bbb9124bb305c09058e32c39a48c": {
				symbol: "AVAX",
				name: "Avalanche",
				address: "0xd00ae08403b9bbb9124bb305c09058e32c39a48c",
				oracle: "0x5498BB86BC934c8D34FDA08E81D444153d0D06aD",
			},
		},
		defaultToken: "0x969771454b8a9b40e5578d38f16c91313fa67baf",
		chain: "Fuji",
		network: "Avalanche"
	},
	1666700000: {
		contract: "0xc153293BACAD8EC778895BE9F50d94DF04B7206B",
		whitelist: {
			"0x6a906063f54ee89b695b6463238d165c3eac6d3e": {
				symbol: "ETH",
				name: "Ether",
				address: "0x6a906063f54ee89b695b6463238d165c3eac6d3e",
				oracle: "0x4f11696cE92D78165E1F8A9a4192444087a45b64"
			},
			"0x6c4387c4f570aa8cadcaffc5e73ecb3d0f8fc593": {
				symbol: "BTC",
				name: "Bitcoin",
				address: "0x6c4387c4f570aa8cadcaffc5e73ecb3d0f8fc593",
				oracle: "0xEF637736B220a58C661bfF4b71e03ca898DCC0Bd"
			},
			"0x7466d7d0c21fa05f32f5a0fa27e12bdc06348ce2": {
				symbol: "ONE",
				name: "One",
				address: "0x7466d7d0c21fa05f32f5a0fa27e12bdc06348ce2",
				oracle: "0xcEe686F89bc0dABAd95AEAAC980aE1d97A075FAD"
			},
			"0xac8bd2b27d45d582a3882e33f626f4e3d3f49c92": {
				symbol: "LINK",
				name: "Chainlink",
				address: "0xac8bd2b27d45d582a3882e33f626f4e3d3f49c92",
				oracle: "0xcd11Ac8C18f3423c7a9C9d5784B580079A75E69a",
			},
		},
		defaultToken: "0x6a906063f54ee89b695b6463238d165c3eac6d3e",
		chain: "Testnet",
		network: "Harmony"
	},
}

export const supportedChains = Object.assign({}, ...Object.keys(chainMapping).map((key, index) => {
	return (
		{
			[key]: {
				chain: chainMapping[key]["chain"],
				network: chainMapping[key]["network"]
			}
		}
	)
}))
